/**
 * YDLenis - Lenis 平滑滚动管理器
 * 依赖: Lenis, GSAP, ScrollTrigger, GSAPUtils.waitFor
 */
(function() {
  'use strict';

  var lenis = null;
  var _lenisReadyResolve;
  window.YDLenisReady = new Promise(function(resolve) {
    _lenisReadyResolve = resolve;
  });

  // 设备检测：只用于 wheel 缓动时长的桌面/移动差异
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
                 || window.innerWidth < 768;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initLenis() {
    if (typeof Lenis === 'undefined') {
      console.warn('[YDLenis] Lenis not found');
      return;
    }

    // 触摸滚动保持原生（Lenis 1.x 的 syncTouch 默认 false，这里不开启）。
    // 历史上这里配置过 smoothTouch / 移动端 touchMultiplier / virtualScroll deltaY 限幅，
    // 但 Lenis 1.2.3 不识别 smoothTouch，后两项只在 syncTouch 路径生效，所以移动端从未被 Lenis
    // 接管——线上一直是「原生触摸 + ScrollTrigger scrub:1」的手感。若将来要让 Lenis 接管触摸，
    // 需单独评估 iOS 地址栏行为与手感变化后再开 syncTouch，不要只加回 smoothTouch。
    lenis = new Lenis({
      duration: isMobile ? 1.0 : 1.2,
      easing: function(t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      // 系统开启「减少动态效果」时不接管滚轮缓动，保留实例与 API（stop/start/scrollTo 照常可用）
      smoothWheel: !reducedMotion,
      wheelMultiplier: 1,
      infinite: false
    });

    lenis.on('scroll', ScrollTrigger.update);
    var tick = function(time) { if (lenis) lenis.raf(time * 1000); };
    gsap.ticker.add(tick);
    gsap.ticker.lagSmoothing(0);

    // ScrollTrigger 刷新（pin 进出、resize、动态内容）会改变文档总高度，
    // 此时必须通知 Lenis 重算可滚动范围，否则到达底部时 Lenis 仍认为
    // 还能滚（自定义滚动条 thumb 显示未到底，wheel 又滚不动）。
    var onRefresh = function() { if (lenis) lenis.resize(); };
    ScrollTrigger.addEventListener('refresh', onRefresh);

    window.YDLenis = {
      instance: lenis,
      scrollTo: function(target, options) { if (lenis) lenis.scrollTo(target, options || {}); },
      stop: function() { if (lenis) lenis.stop(); },
      start: function() { if (lenis) lenis.start(); },
      destroy: function() {
        if (!lenis) return;
        gsap.ticker.remove(tick);
        ScrollTrigger.removeEventListener('refresh', onRefresh);
        lenis.destroy();
        lenis = null;
      },
      get scroll() { return lenis ? lenis.scroll : window.scrollY; },
      get isReady() { return lenis !== null; }
    };

    console.log('[YDLenis] Initialized');
    _lenisReadyResolve();
  }

  function setup() {
    if (typeof GSAPUtils !== 'undefined' && GSAPUtils.waitFor) {
      GSAPUtils.waitFor(['ScrollTrigger'], initLenis);
    } else {
      var checkDeps = setInterval(function() {
        if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && typeof Lenis !== 'undefined') {
          clearInterval(checkDeps);
          initLenis();
        }
      }, 50);
      setTimeout(function() { clearInterval(checkDeps); }, 5000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
